<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <div class="component-content">
        <h1 class="component-header">
          {{userandfileaudit_label}}
        </h1>
      </div>
    </div>
  </div>
  <div class="nugget">
    <div class="row section-padding">
      <div class="col-md-12">
        <div class="row" style="padding-bottom: 20px;">
          <div class="col-md-3 date-space">
            <div class="col-md-6 mb-2 dx-field-item-label-text">{{apps_label}}</div>
            <dx-select-box id="appSelectionDropdownId" showClearButton="true" [searchEnabled]="true"
              [dataSource]="appsList" [value]="selectedAppItem" (onValueChanged)="onAppSelectionChange($event)">
            </dx-select-box>
          </div>
          <div class="col-md-3 date-space-last">
            <div class="col-md-6 mb-2 dx-field-item-label-text">{{users_label}}</div>
            <dx-select-box id="userSelectionDropdownId" showClearButton="true" [searchEnabled]="true"
              [dataSource]="usersList" [value]="selectedUserItem" (onValueChanged)="onUserSelectionChange($event)">
            </dx-select-box>
          </div>
          <div class="col-md-6 date-space-last">
            <div class="col-md-6 mb-2 dx-field-item-label-text">{{file_label}}</div>
            <dx-text-box [value]="dataOrgNodeId" [showClearButton]="true" id="filetextId"
              (onValueChanged)="filevalueChanged($event)">
            </dx-text-box>
            <dx-button text="Select" (onClick)="openFileSelectionPopup()" [elementAttr]="{ id: 'selectNodeDirBtn'}">
            </dx-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row dateSection">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-6 date-space customDates">
            <div class="col-md-6 mb-2 dx-field-item-label-text">{{fromDatePH}}</div>
            <dx-date-box placeholder="{{fromDatePH}}" displayFormat="MM/dd/yyyy" width="98%" [(value)]="fromDate"
              [max]="toDate" [(ngModel)]="fromDate" (onValueChanged)="onDateSelectionchange($event)" type="date"
              [showClearButton]="false" id="fromDateSelectorId">
            </dx-date-box>
          </div>
          <div class="col-md-6 date-space customDates" style="padding-left: 5px;">
            <div class="col-md-6 mb-2 dx-field-item-label-text">{{toDatePH}}</div>
            <dx-date-box placeholder="{{toDatePH}}" width="97%" [(value)]="toDate" [(ngModel)]="toDate"
              (onValueChanged)="onDateSelectionchange($event)" type="date" [min]="fromDate" [disabled]="!fromDate"
              [showClearButton]="false" id="toDateSelectorId">
            </dx-date-box>
          </div>
        </div>
      </div>
    </div>


    <div class="data-grid-wrapper">
      <dx-data-grid id="userandfileAuditGrid" [dataSource]="userandfileAuditRecords" #userandfileAuditGrid
        [rowAlternationEnabled]="true" class="hideEditIcon" [allowColumnResizing]="true" [columnAutoWidth]="true"
        (onCellClick)="showMessageDetails($event)">
        <dxo-remote-operations [sorting]="false" [paging]="true" [filtering]="true" [summary]="true">
        </dxo-remote-operations>
        <dxo-header-filter [visible]="false" [allowSearch]="true"></dxo-header-filter>
        <dxo-paging [pageSize]="10"></dxo-paging>
        <dxo-pager [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
        <dxo-export [enabled]="true" fileName="User and File Audit"></dxo-export>
        <dxo-search-panel [visible]="true" [width]="220" placeholder="{{search}}"></dxo-search-panel>
        <dxo-editing mode="row" [allowUpdating]="false" [allowDeleting]="false" [useIcons]="false">
        </dxo-editing>
        <dxi-column dataField="date_time" [caption]="date_time_label" [allowHeaderFiltering]="false"
          [allowSorting]="false" cellTemplate="cellTemplateDatetime"></dxi-column>
        <dxi-column dataField="app_id" [caption]="app_label" [allowHeaderFiltering]="false" [allowSorting]="false">
        </dxi-column>
        <dxi-column dataField="user_id" [caption]="users_label" [allowHeaderFiltering]="false" [allowSorting]="false">
        </dxi-column>
        <dxi-column dataField="message" [caption]="message_label" [width]="200" [allowHeaderFiltering]="false"
          [allowSorting]="false" cellTemplate="messageTemplate"></dxi-column>
        <dxi-column dataField="file_name" [caption]="file_label" [allowHeaderFiltering]="false" [allowSorting]="false"
          cellTemplate="fileTemplate"></dxi-column>
        <div *dxTemplate="let data of 'cellTemplateDatetime'">
          <span title="{{ data.value }}">{{data.value | localtime}}</span>
        </div>
        <div *dxTemplate="let data of 'messageTemplate'">
          <a class="pointer execution" [title]="data.value">{{data.value}}</a>
        </div>
        <div *dxTemplate="let data of 'fileTemplate'">
          <span title="{{data.value}}">{{getFilePath(data.value)}}</span>
        </div>
      </dx-data-grid>
    </div>


    <dx-popup id="pathSelectionPopupId" class="popup dataorgPopup" [height]="'auto'" width="80%" [showTitle]="true"
      [title]="path_selection" [dragEnabled]="false" [closeOnOutsideClick]="false"
      [(visible)]="fileSelectionPopupVisible" (onHidden)="hideDataOrgPane()">
      <div *dxTemplate="let data of 'content'">
        <app-data-org [currentNode]="currentNode" [isVisible]="true"></app-data-org>
        <div style="padding-bottom:10px;" class="col-md-12  text-right"
          *ngIf="dataOrgComp && dataOrgComp.isVisible  === true">
          <dx-button text="Ok" (onClick)="getNodeDir()" [elementAttr]="{ id: 'selectNodeDirBtn'}"></dx-button>
        </div>
      </div>
    </dx-popup>

    <dx-popup id="messagePopupId" class="popup customPopup" [(visible)]="isMessagePopup" [height]="250" [width]="400"
      [showTitle]="true" [title]="message_label" [dragEnabled]="false" [closeOnOutsideClick]="false"
      (onHidden)="hideMessagePopup()">
      <div *dxTemplate="let data of 'content'" id="messageId">
        <dx-scroll-view #scrollView id="scrollview" scrollByContent="true" showScrollbar="true">
          <div class="">
            <p style="padding-top:10px;word-wrap: break-word">{{messageValue}}</p>
          </div>
        </dx-scroll-view>
      </div>
    </dx-popup>